var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75977 12.1732C3.75977 10.2497 3.75977 9.28839 4.19673 8.49177C4.63201 7.69432 5.42947 7.20021 7.02354 6.21032L8.70416 5.1675C10.389 4.12131 11.2318 3.59863 12.1629 3.59863C13.094 3.59863 13.936 4.12131 15.6216 5.1675L17.3022 6.21032C18.8963 7.20021 19.6938 7.69432 20.1299 8.49177C20.566 9.28839 20.566 10.2497 20.566 12.1723V13.4513C20.566 16.7285 20.566 18.368 19.5812 19.3864C18.5972 20.4049 17.0123 20.4049 13.8435 20.4049H10.4823C7.31345 20.4049 5.72862 20.4049 4.74461 19.3864C3.75977 18.368 3.75977 16.7294 3.75977 13.4513V12.1732Z",
    stroke: "#322c36"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear_gradient",
    x1: 3.75977,
    y1: 12.0018,
    x2: 20.566,
    y2: 12.0018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#554494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6145"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.35197d3136df4e18a3f2b7f6960ad1e2.svg";
export { ForwardRef as ReactComponent };